import React from 'react'
import HeroSection from './HeroSection'
import Logo from '../Logo'

export default () => (
  <HeroSection
    swapOnMobile
    left={
      <img
        className="screenshot-left"
        src="/images/app/app-screen-1@2x.png"
        alt="showing overall steps taken"
      />
    }
    right={
      <div className="centered-on-mobile">
        <Logo className="hide-on-mobile" style={{ marginBottom: 24 }} />
        <h1>Own your holistic well-being</h1>
        <p className="description">
          A simple way to train your physical, emotional, and financial
          well-being.
        </p>
        <div className="store-badges">
          <a
            href="https://itunes.apple.com/us/app/sqrl/id1350048019?ls=1&mt=8"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/logos/app-store-badge.png"
              alt="app on apple app store"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.eighty4inc.sqrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/logos/play-store-badge.png"
              alt="app on google play store"
            />
          </a>
        </div>
      </div>
    }
  />
)
